import React from 'react'
import whatsapp from 'assets/images/whatsapp.webp'
import styles from './WhatsappCTA.module.scss'

const WhatsappCTA = ({
  link,
  message = 'Precisa de ajuda com esse imóvel?',
}) => {
  return (
    <a
      href={link}
      className={styles.wrapper}
      target="_blank"
      rel="noreferrer"
      data-testid="link"
    >
      <span>{message}</span>
      <img loading="lazy" src={whatsapp} alt="Pedir ajuda no whatsapp" />
    </a>
  )
}

export default React.memo(WhatsappCTA)
